export default "__VITE_ASSET__5f28303c__"